import type { IUserDomain } from '@/entities/domain.entity';
import type { IBuild } from '@/entities/build.entity';
import { api } from './http';

export async function fetchDomains() {
	const { data } = await api.get<{ domains: IUserDomain[] }>('/domains');
	return data.domains;
}

export async function fetchDomain(id: number) {
	const { data } = await api.get<{ domain: IUserDomain; builds: IBuild[]; buildsCount: number }>(`/domains/${id}`);
	return data;
}

export async function createDomain(hostname: string) {
	const { data } = await api.post<{ domain: IUserDomain }>('/domains', { hostname });
	return data.domain;
}

export async function checkDomain(id: number) {
	const { data } = await api.post<{ domain: IUserDomain }>(`/domains/${id}/check`);
	return data.domain;
}

export async function checkDomainReachability(id: number) {
	const { data } = await api.post<{ domain: IUserDomain }>(`/domains/${id}/reachability-check`);
	return data.domain;
}
